import React from "react";
import { ToastContainer } from "react-toastify";
import ViewProductVariant from "../../components/ProductManager/productVariants/ViewProductVariant";

export const ViewProductVariantPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewProductVariant />
        </div>
      </div>
    </div>
  );
};
